import { StudentOnlineApplicationStatus } from '@modules/types/graphql';

export const onlineApplicationStatusTranslates = {
    [StudentOnlineApplicationStatus.empty]: 'students:blocks.online_application_status.empty',
    [StudentOnlineApplicationStatus.pending]: 'students:blocks.online_application_status.pending',
    [StudentOnlineApplicationStatus.correction]:
        'students:blocks.online_application_status.correction',
    [StudentOnlineApplicationStatus.schoolApproved]:
        'students:blocks.online_application_status.school_approved',
    [StudentOnlineApplicationStatus.approved]: 'students:blocks.online_application_status.approved',
    [StudentOnlineApplicationStatus.rejected]: 'students:blocks.online_application_status.rejected',
};
